<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('name')">
              Bisnis Unit
              <i
                :class="
                  currentSort === 'name'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('server')">
              Server
              <i
                :class="
                  currentSort === 'server'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ list.id }}</td>
            <td>{{ list.name }}</td>
            <td>{{ list.server }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <BisnisUnit
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    BisnisUnit: () => import('@/views/MasterData/Edit/SAP/BisnisUnit.vue'),
  },

  props: {
    isEdit: Boolean,
  },

  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        name: '',
        server: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: 1,
          name: 'BCE',
          server: 'BCE',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: 2,
          name: 'GEMS',
          server: 'GEMS',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          name: 'BKES',
          server: 'BKES',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          name: 'SUN',
          server: 'GEMS',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          active: 'Active',
          note: 'Test 3',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        name: data.name,
        server: data.server,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    bisnisUnitData() {
      const result = this.$store.state.mdDatabaseStore.bisnisUnitData
      return result
    },
    sortedData() {
      return this.bisnisUnitData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
